import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 60px);
  padding: 20px;
  overflow: auto;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Title = styled.h1`
  color: #3d3d3d;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const SearchArea = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
`;
export const Content = styled.div``;
